module.exports = __webpack_public_path__ + "static/assets/d1680a847046403c792a689d2572ff80.jpg";